// On mobile (especially iOS Safari), the browser can drop the WebGL context
// under memory pressure. The older atlatl-visual component doesn't handle
// this gracefully, which sometimes manifests as a full page auto-reload.
// Calling preventDefault() on webglcontextlost tells the browser the page
// will handle the loss and suppresses the default recovery (which can
// include reloading). We register in the capture phase on document so we
// catch the event no matter when/where the canvas is created.
document.addEventListener('webglcontextlost', function (e) {
  e.preventDefault();
  console.warn('[chair] WebGL context lost — suppressed default browser reload');
}, true);

var _st1 = 0;
$(window).scroll(function() {
  var _n = Date.now(); if (_n - _st1 < 100) return; _st1 = _n;
  if ($(this).scrollTop() > 300) {
    $('.stock-top').css('opacity', 0);
  } else {
    $('.stock-top').css('opacity', 1);
  }
});

// Function to calculate the length of each SVG path
const calculatePathLength = (path) => {
  const length = path.getTotalLength();
  path.style.strokeDasharray = length;
  path.style.strokeDashoffset = length;
};

// Animate SVG paths — scoped to the loading screen only, not every SVG
// on the page (previously `document.querySelectorAll("svg path")` was
// animating every icon, illustration, and chart SVG sitewide at 60fps).
const loadingBg = document.querySelector('.loading_bg');
const svgPaths = loadingBg
  ? loadingBg.querySelectorAll("svg path")
  : [];
svgPaths.forEach(path => {
  calculatePathLength(path);
  gsap.to(path, { strokeDashoffset: 0, duration: 4, ease: "power1.inOut", repeat: -1, yoyo: false });
});

// Animate each letter in the h2 element
const letters = document.querySelectorAll("#loading-text span");
letters.forEach((letter, index) => {
  gsap.to(letter, {
    opacity: 1,
    duration: 1,
    ease: "power1.inOut",
    delay: index * (1 / letters.length),
    repeat: -1,
    repeatDelay: 2
  });
});

// Function to stop all animations
const stopAllAnimations = () => {
  console.log('Stopping animations...'); // Debug log
  
  // Kill all GSAP animations
  svgPaths.forEach(path => gsap.killTweensOf(path));
  letters.forEach(letter => gsap.killTweensOf(letter));
  
  // Optionally hide the loading screen
  // loadingBg.style.display = 'none';
  
  observer.disconnect();
};

// Create a MutationObserver to watch for changes in the class attribute
const observer = new MutationObserver(mutations => {
  console.log('Mutation detected'); // Debug log
  mutations.forEach(mutation => {
    if (mutation.attributeName === 'class') {
      console.log('Class changed:', loadingBg.className); // Debug log
      if (loadingBg.classList.contains('dopple_loaded')) {
        console.log('dopple_loaded class found!'); // Debug log
        stopAllAnimations();
      }
    }
  });
});

// Start observing the loadingBg div for attribute changes
observer.observe(loadingBg, { attributes: true });

// Also check immediately in case the class is already present
if (loadingBg.classList.contains('dopple_loaded')) {
  stopAllAnimations();
}

// Your existing code continues...
function show_hide_options(es){
    $(es).toggleClass('activemore');
    $('.o_2184551, .o_2184553, .o_2184554, .o_2184555, .o_2184556, .o_2184557, .o_2206346').toggleClass('optionhidden');

    // Change button text
    if ($(es).hasClass('activemore')) {
        $(es).text('LESS CUSTOMIZATION');
    } else {
        $(es).text('MORE CUSTOMIZATION');
    }
}

 $(".gallary-bg").click(function() {
    $(this).addClass("animated fadeOut");
    $(this).children().children().addClass("fadeLeft");
    $(this).children().remove();
    var rmBg = $(this);
    setTimeout(() => {
        rmBg.removeClass("gallary-bg-block");
    }, 10);
});
const closemodal = img => {
    $(img).addClass("animated fadeOut");
    $(img).children().children().addClass("fadeLeft");
    $(img).children().remove();
    var rmBg = $(img);
    setTimeout(() => {
        rmBg.removeClass("gallary-bg-block");
    }, 400);
}
const openModal = img => {
    const imgClone = $(img).closest('.mw-stack__item').find('input[type="radio"]').attr('data-image');
  // console.log(imgClone);
    $(".gallary-bg").addClass("gallary-bg-block")
   // $(".gallary-bg").html('<div class="img_center"><img src="' + imgClone + '" /></div>');
    $(".gallary-bg img").attr('onclick', '');
    $(".gallary-bg img").addClass("animated fadeIn");
    $(".gallary-bg").removeClass("animated fadeOut");
    $('.gallary-bg img').attr('id', 'myimage');

    // magnify("myimage", 2);
}
//  if($( window ).width() > 767){
$(document).ready(function() {
  $('.price-item--regular').attr('style','opacity:0');
    var countDownDate = new Date("Dec 1, 2022 15:37:25").getTime();
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    setTimeout(function() {
        

        $('#custom_add_to_cart_btn').click(function(e) {

            var isvalid = true;

            $('div[data-helptext-type="required"]').each(function() {
             
                var text = $(this).text();
                var select_val = $(this).closest('.mw-option--required').find('select').val();
                if (select_val != undefined && select_val != 'undefined') {
                    if (select_val == '') {
                        $('#variant_error').remove();
                        $('.mw-apo-container').append('<p id="variant_error" style="color:red;">' + text + '</p>');
                        isvalid = false;
                        return false;
                    } else {
                        $('#variant_error').remove();
                    }
                } else {
                    if ($(this).closest('.mw-option--required').find('input[type="radio"]:checked').length < 1) {
                        $('#variant_error').remove();
                        $('.mw-apo-container').append('<p id="variant_error" style="color:red;">' + text + '</p>');
                        isvalid = false;
                        return false;
                    } else {
                        $('#variant_error').remove();
                    }
                }
            })
        })
        //$('.mw-apo-add-to-cart-cloned').hide();
      //change_image($('.product-form input[type="radio"]')); 
    }, 5000);

    setTimeout(function() {
		//console.log('time started');
        //product-form__submit button button--full-width button--primary mw-apo-add-to-cart-cloned
        $('.mw-label').hover(function() {
            var img = $(this).find('input[type="radio"]').attr('data-image');
//console.log('time hovered');
            setTimeout(function() {
               
                if (img != null && img != undefined && img != 'undefined') {
                  // $('.tippy-box').attr('onclick', 'openModal(this)');
				  // console.log('time openModal');
				   $(".gallary-bg").html('<div class="img_center"><img src="' + img + '" /></div>');
                }
            }, 200);
        })
        setTimeout(function() {
            $('.chair_summary').each(function() {
               // $(this).find('h4').addClass('tab');
               // $(this).find('ul').addClass('tabcontent');
               // $(this).find('ul').hide();
            })
            $('.tab').click(function() {

                if ($(this).hasClass('active')) {
                   if ($(this).attr('data-id') == 'o_520080') {
                        $('#o_520087').hide();
                    }
                    if ($(this).attr('data-id') == 'o_2081593') {
                        $('#o_2081594').hide();
                        $('#o_520257').hide();
                    }
                    if ($(this).attr('data-id') == 'o_502386') {
                        $('#o_525895').hide();
                    } 
                   $('.tabcontent').hide(400);
                    $('.tab').removeClass('active');

                } else {
                    // Anthros Metrics 
                    if ($(this).attr('data-id') == 'o_520080') {
                        $('#o_520087').show();
                    } else if ($(this).attr('data-id') != undefined) {
                        $('#o_520087').hide();
                    }
                    // Casters 
                    if ($(this).attr('data-id') == 'o_2081593') {
                        $('#o_2081594').show();
                        $('#o_520257').show();
                        $('#o_638388').show();
                    } else if ($(this).attr('data-id') != undefined) {
                        $('#o_2081594').hide();
                       // $('#o_520257').hide();
                       // $('#o_638388').hide();
                    }
                    // Trim Options
                    if ($(this).attr('data-id') == 'o_502386') {
                        $('#o_525895').show();

                    } else if ($(this).attr('data-id') != undefined) {
                        $('#o_525895').hide();
                    }

                    if ($(this).attr('data-id') == 'o_638387') {
                        //$('#o_638388').toggle();

                    } else if ($(this).attr('data-id') != undefined) {
                       // $('#o_638388').hide();
                    }

                    $('.tabcontent').hide();
                    $(this).closest('.chair_summary').find('.tabcontent').first().show(400);
                    $('.tab').removeClass('active');
                    $(this).toggleClass('active');
               }
			   if($( window ).width() < 993){
		   $("html, body").animate({
            scrollTop: $(this).offset().top - 435
        }, 300); 
		   }
            })
        }, 2000);
        // cHANGE IMAGE FUNCTION
        function numberWithCommas(number) {
            var parts = number.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return parts.join(".");
        }

        function change_image(et) {
            var rules = localStorage.getItem('rules');
            var variant_name = $(et).attr('name');
            var isvalid = true;

            $('div[data-helptext-type="required"]').each(function() {
              
                var text = $(this).text();
                var select_val = $(this).closest('.mw-option--required').find('select').val();
                if (select_val != undefined && select_val != 'undefined') {
                    if (select_val == '') {

                        isvalid = false;
                        // return false;
                    } else {
                        $('#variant_error').remove();
                    }
                } else {
                    if ($(this).closest('.mw-option--required').find('input[type="radio"]:checked').length < 1) {

                        isvalid = false;
                        // return false;
                    } else {
                        $('#variant_error').remove();
                    }
                }

            })
        
            if (isvalid == true) {

                $('#custom_add_to_cart_btn').hide();
                $('.mw-apo-add-to-cart-cloned').show();
            } else {
              //  $('#custom_add_to_cart_btn').show();
              //  $('.mw-apo-add-to-cart-cloned').hide();
			   $('#custom_add_to_cart_btn').hide();
                $('.mw-apo-add-to-cart-cloned').show();
            }
            var image_name = '';

            var pr_price = $('#product_price').val();
            pr_price = parseFloat(pr_price);

            var variant_price = 0;
            $('.product-form input[type="radio"]:checked').each(function() {

                variant_price = variant_price + parseFloat($(this).attr('data-price'));
            })
            $('.product-form select option:selected').each(function() {
                var prc = $(this).attr('data-price');
                if (prc != undefined && prc != 'undefined' && prc != null && prc != '') {
                    variant_price = variant_price + parseFloat($(this).attr('data-price'));
                }
            })
            var total_price = pr_price + variant_price;
            //$('#product_price').val(total_price)
			if(!isNaN(total_price)){
			var extra_price = total_price + 345
            $('.price-item--regular').text('$' + numberWithCommas(total_price.toFixed(2)) + '');
            $('.extra_price').text('$'+numberWithCommas(extra_price.toFixed(2)));
            
			//$('.price-item--regular').attr('style','opacity:1');
			}
            $('.klarna_price').text('$' + (total_price / 4).toFixed(2));
            variant_price = parseFloat(variant_price);

            $.each(JSON.parse(rules), function(index, value) {
                var is_true = true;
                var str1 = value.rule.title;
                if (value.rule.title != '' && str1.indexOf('{index}') != -1) {
                    $.each(value.rule.conditions, function(ind, val) {
                        var option_val = $('input[name="mw_opts[' + val.option_id + ']"]:checked').val();
                       
                        if (option_val == 'v_502382_l6dixwf8') {
                            $('.4-stroke-soft').show();
                        } else if (option_val == 'v_2883688') {
                            $('.4-stroke-soft').hide();
                        }
                        //if(val.values[0] != option_val){
                        if ($.inArray(option_val, val.values) == -1) {
                            is_true = false;
                        }
                    })
                } else {
                    is_true = false;
                }
                if (is_true == true) {
                 
                 

                    return value.rule.title;

                   // return false;
                }
             
            })
        }
        
        // NEW FUNCTION: Update section titles for o_2184551 and o_2184552
        function updateSectionTitles() {
            // Remove any existing new_title_name spans from section headers only
            $('.o_2184551 .shapeknit_text h2 .new_title_name, .o_2184551 .port_leather_text h2 .new_title_name').remove();
            $('.o_2184552 .standard_black_text h2 .new_title_name, .o_2184552 .wood_text h2 .new_title_name, .o_2184552 .specialty_text h2 .new_title_name').remove();
            
            // For o_2184551 (Fabric) - SIMPLIFIED
            $('.o_2184551 input[type="radio"]:checked').each(function() {
                let title_name = $(this).closest('div').find('.title_name').text();
                if($(this).val() == 'v_19129218'){
                    title_name += '<del>$199</del>'
                }
                let title_format = title_name.split('+');
                let bold_title = '';
                if(title_format[1] != undefined){
                    bold_title = '+'+title_format[1];
                }
                
                // Determine which section this radio belongs to
                let parentSection = $(this).closest('.mw-option__value').parent();
                let targetH2 = null;
                
                // Check if parent container has shapeknit or port_leather class
                if(parentSection.hasClass('shapeknit')) {
                    targetH2 = $('.o_2184551 .shapeknit_text h2');
                } else if(parentSection.hasClass('port_leather')) {
                    targetH2 = $('.o_2184551 .port_leather_text h2');
                }
                
                if(targetH2 && targetH2.length) {
                    targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
                }
            });
            
            // For o_2184552 (Back Panel) - SIMPLIFIED (removed priceMap and strike-through logic for wood/specialty)
            $('.o_2184552 input[type="radio"]:checked').each(function() {
                let title_name = $(this).closest('div').find('.title_name').text();
                let title_format = title_name.split('+');
                let bold_title = '';
                if(title_format[1] != undefined){
                    bold_title = '+'+title_format[1];
                }
                
                // Determine which section this radio belongs to
                let parentSection = $(this).closest('.mw-option__value').parent();
                let targetH2 = null;
                
                // Check if parent container has the appropriate class
                if(parentSection.hasClass('standard_black')) {
                    targetH2 = $('.o_2184552 .standard_black_text h2');
                    targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
                } else if(parentSection.hasClass('wood_section')) {
                    targetH2 = $('.o_2184552 .wood_text h2');
                    targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
                } else if(parentSection.hasClass('specialty')) {
                    targetH2 = $('.o_2184552 .specialty_text h2');
                    targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
                } else if(parentSection.hasClass('bitcoin_data')) {
                    // For bitcoin, display in the specialty_text h2 (same location)
                    targetH2 = $('.o_2184552 .specialty_text h2');
                    targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
                }
            });
            // For o_2184552 (Back Panel) - WITH PRICE STRIKE-THROUGH
            /*$('.o_2184552 input[type="radio"]:checked').each(function() {
                let title_name = $(this).closest('div').find('.title_name').text();
                let title_format = title_name.split('+');
                let bold_title = '';
                if(title_format[1] != undefined){
                    bold_title = '+'+title_format[1];
                }
                
                // Price map for strike-through prices
                var priceMap = {
                    'v_18919695': '$149',
                    'v_18919694': '$79',
                    'v_20901620': '$79',
                    'v_19580847': '$79',
                    'v_19580848': '$79',
                    'v_19580849': '$79',
                    'v_18919696': '$299',
                    'v_18919697': '$79',
                    'v_18919698': '$79',
                    'v_19939682': '$79',
                    'v_19939683': '$79',
                    'v_20110214': '$79',
                    'v_19580996': '$79',
                    'v_19580997': '$79',
                    'v_20616603': '$79'  // Added the new AMERICA back option
                };
                
                var radioId = $(this).attr('id');
                var strikePrice = priceMap[radioId] || '';
                
                // Determine which section this radio belongs to
                let parentSection = $(this).closest('.mw-option__value').parent();
                let targetH2 = null;
                
                // Check if parent container has the appropriate class
                if(parentSection.hasClass('standard_black')) {
                    targetH2 = $('.o_2184552 .standard_black_text h2');
                    targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
                } else if(parentSection.hasClass('wood_section')) {
                    targetH2 = $('.o_2184552 .wood_text h2');
                    // Add strike price inside the b tag for wood section
                    if(strikePrice) {
                        let strikePriceHTML = '<span class="strike-price" style="text-decoration: line-through; color: #999999; margin-right: 3px;">' + strikePrice + ' </span>';
                        targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ strikePriceHTML + bold_title+'</b>'+'</span>');
                    } else {
                        targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
                    }
                } else if(parentSection.hasClass('specialty')) {
                    targetH2 = $('.o_2184552 .specialty_text h2');
                    // For specialty, add strike price inside the b tag
                    if(strikePrice) {
                        let strikePriceHTML = '<span class="strike-price" style="text-decoration: line-through; color: #999999; margin-right: 3px;">' + strikePrice + ' </span>';
                        targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ strikePriceHTML + bold_title+'</b>'+'</span>');
                    } else {
                        targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
                    }
                } else if(parentSection.hasClass('bitcoin_data')) {
                    // For bitcoin, display in the specialty_text h2 (same location)
                    targetH2 = $('.o_2184552 .specialty_text h2');
                    // Add strike price inside the b tag
                    if(strikePrice) {
                        let strikePriceHTML = '<span class="strike-price" style="text-decoration: line-through; color: #999999; margin-right: 3px;">' + strikePrice + ' </span>';
                        targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ strikePriceHTML + bold_title+'</b>'+'</span>');
                    } else {
                        targetH2.append('<span class="new_title_name"> '+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
                    }
                }
            });*/
        }
        
        setTimeout(function() {
			
    $('.product-form input[type="radio"], .product-form select').each(function() {
             
                var name = change_image($(this));
 
            })
			$('.product-form input[type="radio"]:checked').each(function(){
				 let title_name = $(this).closest('div').find('.title_name').text();
				 if($(this).val() == 'v_19129218'){
					 //title_name += '<del>$199</del>'
				 }
				 let title_format = title_name.split('+');
				 let bold_title ='';
				  if(title_format[1] != undefined){
					  bold_title = '+'+title_format[1];
				  }
				 $(this).closest('.chair_summary').find('.new_title_name').remove();
				 $(this).closest('.chair_summary').find('h4').append('<span class="new_title_name">'+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
				 $(this).closest('.mw-option__value').addClass('radio_active');
				
			})
			
			// Initialize section titles on page load
			setTimeout(function() {
				updateSectionTitles();
			}, 500);
			
              $('.product-form input[type="radio"]').change(function() {
				 let title_name = $(this).closest('div').find('.title_name').text();
				 if($(this).val() == 'v_19129218'){
					 //title_name += '<del>$199</del>'
				 }
				 let title_format = title_name.split('+');
				 let bold_title ='';
				  if(title_format[1] != undefined){
					  bold_title = '+'+title_format[1];
				  }
				 $(this).closest('.chair_summary').find('.new_title_name').remove();
				 $(this).closest('.chair_summary').find('h4').append('<span class="new_title_name">'+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
				 $(this).closest('.mw-option__container').find('.mw-option__value').removeClass('radio_active');
				$(this).closest('.mw-option__value').addClass('radio_active');
				  
			  })
            $('.product-form input[type="radio"], .product-form select').change(function() {
				var valchecked = $(this).val();
				//console.log('.fixed_select_option='+valchecked);
				console.log('is_checked='+$(this).is(":checked"));
				console.log('valchecked='+valchecked);
				$(this).closest('.mw-option__container').find('.mw-option__value').removeClass('radio_active');
				$(this).closest('.mw-option__value').addClass('radio_active');
				if(valchecked == 'v_18929376'){
					
					$('body').addClass('darkmode');
				}
				if(valchecked == 'v_18929375'){
					
					$('body').removeClass('darkmode');
				}
              
			var img_click = $(this).attr('data-image');
			//$(this).closest('.mw-option').find('.fixed_select_option').hide();
			if(img_click != '' && img_click != undefined && img_click != 'undefined' && img_click != null){
				//$(this).closest('.mw-stack__item').find('.fixed_select_option').show();
				//alert('sds');
			}
                if (valchecked == 'v_17990463') {
                    $('#v_17990486').click();
                }
                if (valchecked == 'v_17990464') {
                    $('#v_17990487').click();
                }
				if( valchecked == "v_3035424" || valchecked == "v_3035425" || valchecked == "v_520087_lhbj3vep"){
					$('.showhide_weight').show();
				}else{
					$('.showhide_weight').hide();
				}
                var name = change_image($(this));
                
                // Update section titles for o_2184551 and o_2184552 when radio buttons change
				if($(this).is(':radio') && $(this).closest('.o_2184551, .o_2184552').length) {
					updateSectionTitles();
				}

            })
        }, 1000);

    }, 3000);
    var _st2 = 0;
    $(window).scroll(function() {
        var _n = Date.now(); if (_n - _st2 < 100) return; _st2 = _n;
        var sticky = $('.header-wrapper'),
            scroll = $(window).scrollTop();

        if (scroll >= 50) sticky.addClass('added_class');
        else sticky.removeClass('added_class');
    });

    var cache_hash = window.mwApoInit.cache_hash;
    var product_id = window.mwApoInit.product.id;
    var variants_id = window.mwApoInit.product.variants[0].id;
    // Desktop Start
  
    // Desktop End 
    // Mobile Start
    //if ($(window).width() < 993) {
	let checkExist = setInterval(function() {
    if ($('.mw-apo-container').length) {
        // Fire your event
      //  setTimeout(function() {
            $.getJSON('https://apo-api.mageworx.com/front/product/anthroschair.myshopify.com/' + cache_hash + '/' + product_id + '/' + variants_id + '.js', function(jd) {

                localStorage.setItem('rules', JSON.stringify(jd.rules));
                var options = jd.options;
                var values = jd.values;

                var html = '';

                var i = 0;
                setTimeout(function() {
                    $.each(values, function(key, val) {
                        if (val.value.input_type == 'select') {
                            $('select option[value="' + val.value.id + '"]').attr('data-price', val.value.pricing.price);

                        }
                        $('#' + val.value.id).attr('data-price', val.value.pricing.price);
                        $('#' + val.value.id).closest('.mw-stack__item').append('<span class="title_name">' + val.value.title + '</span>');
                        if (val.value.id == "v_3993314" || val.value.id == "v_3993315") {
                            $('#' + val.value.id).closest('.mw-stack__item').append(val.value.description);
                        }
						
						if(val.value.images[0] != null && val.value.images[0] != undefined){
					  var hover_image = val.value.images[0]['url'];
					$('#'+val.value.id).attr('data-image',val.value.images[0]['url']); 
				var disc_class = '';
				var option_description = '';
				if(val.value.description != ''){
					disc_class = 'with_description';
					option_description = '<div class="option_description">'+val.value.description+'</div>';
					
				}
					if(val.value.images[0].hover == true ){
					if(val.value.is_default == true){			
				//	console.log(val.value.is_default);
			
					
					}else{
					
						
					}
				  }else if(val.value.description != ''){
					  var style = 'none';
					  if(val.value.is_default == true){
						  style = 'block';
						  }
					
					  
					  
				  }
					
				  }else{
					  
					  
				  }
						
                        //$('#'+val.value.id).closest('.mw-stack__item').append(val.value.description);
                    })
                    var event = new Event("optionsReady");

                    window.dispatchEvent(event);
                }, 1000);

                $.each(options, function(index, value) {

                    setTimeout(function() {
                        $('#' + value.id).wrap('<div class="chair_summary '+value.id+'"></div>');
                        //o_2080842 o_520257 o_2080843
                        if (value.id != 'o_2081594' && value.id != 'o_2080843' && value.id != 'o_520257' && value.id != 'o_525895' && value.id != 'o_638388') {
                           // $('#' + value.id).addClass('tabcontent');
							
							 if(value.id == "o_2081589"){
					$('<h4 class="tab1 active" data-id="'+value.id+'" >'+value.title+'</h4>').insertBefore($('#'+value.id)); 
					 $('#'+value.id).show();
				 }else{
					$('<h4 class="tab1" data-id="'+value.id+'" >'+value.title+'</h4>').insertBefore($('#'+value.id)); 
					 
				 }
                         //   $('<h4 class="tab" data-id="' + value.id + '" >' + value.title + '</h4>').insertBefore($('#' + value.id));
                        }
                        $('#' + value.id).find('.mw-text--style-strong').html(value.name);
                        $('#' + value.id).append(value.description);

                    }, 100);

                    i = i + 1;
					
					if(value.id == "o_2184551"){
						setTimeout(function() {
					$('[data-value-id="v_18919683"], [data-value-id="v_18919684"], [data-value-id="v_18919685"], [data-value-id="v_18919686"], [data-value-id="v_18919687"], [data-value-id="v_18919688"]').wrapAll('<div class="shapeknit"/>'); 
					
					$('div.mw-option__value[data-value-id="v_18919689"], div.mw-option__value[data-value-id="v_18919690"], div.mw-option__value[data-value-id="v_18919691"], div.mw-option__value[data-value-id="v_18919692"]').wrapAll('<div class="port_leather"/>'); 
				  }, 1000);
				 }	
			if(value.id == "o_2184552"){
				//setTimeout(function() {
					$('[data-value-id="v_18919693"]').wrapAll('<div class="standard_black back_items"/>'); 
					$('[data-value-id="v_18919694"], [data-value-id="v_19580847"], [data-value-id="v_18919695"], [data-value-id="v_19580848"], [data-value-id="v_19572775"], [data-value-id="v_19580849"], [data-value-id="v_19399710"], [data-value-id="v_20901620"]').wrapAll('<div class="wood_section back_items"/>'); 
					$('[data-value-id="v_18919696"], [data-value-id="v_18919697"], [data-value-id="v_18919698"], [data-value-id="v_19371518"], [data-value-id="v_19371519"], [data-value-id="v_18919699"], [data-value-id="v_19371561"], [data-value-id="v_18919702"], [data-value-id="v_18919703"], [data-value-id="v_19354919"], [data-value-id="v_19354920"], [data-value-id="v_18919700"], [data-value-id="v_18919701"], [data-value-id="v_19939682"], [data-value-id="v_19939683"], [data-value-id="v_20110214"], [data-value-id="v_20616603"]').wrapAll('<div class="specialty back_items"/>'); 
					
					$('[data-value-id="v_19580997"],[data-value-id="v_19580996"]').wrapAll('<div class="bitcoin_data"/>'); 
					
				  // }, 1000);
				 }	
					
                });

                $('.list_items .item').click(function() {
                    var show_id = $(this).attr('data-id');
                    $('.mw-option--type-swatch').hide();
                    $('#' + show_id).show();
                    $('.list_items .item').removeClass('active');
                    $(this).addClass('active');
                })

            });
			//setTimeout(function() {
					$('<div class="shapeknit_text"><h2>Athlon Performance Fabric</h2><p>A high performance upholstery designed to meet the demands of daily use while providing exceptional comfort and style.</p></div>').insertBefore($('div[data-value-id="v_18919683"]'));
					 $('<div class="port_leather_text"><h2>Port Leather Alternative</h2><p>An environmentally conscious synthetic leather that is phthalate free. Wipeable for cleaning and disinfecting</p></div>').insertBefore($('div[data-value-id="v_18919689"]'));
					 
					 
					 $('<div class="standard_black_text back_items"><h2>Standard Black</h2></div>').insertBefore($('div[data-value-id="v_18919693"]'));
					 $('<div class="wood_text back_items"><h2 style="display: inline; margin-right: 3px;">Wood</h2><sup id="backs_infocon" style="display: inline;">&#9432;</sup><span id="backs_info" style="display: none;">Crafted with a refined wood aesthetic that captures the organic beauty and texture of natural wood grain</span></div>').insertBefore($('div[data-value-id="v_18919694"]'));
					 $('<div class="specialty_text back_items"><h2>Specialty</h2></div>').insertBefore($('div[data-value-id="v_18919696"]'));
					  $('#backs_infocon').click(function() {
		//console.log('dsfsdf');
        $('#backs_info').toggle(); // This toggles the display
    });
    // Optional: Toggle on hover
    $('#backs_infocon').hover(
        function() {
            $('#backs_info').show(); // Show on mouse enter
        }, 
        function() {
            $('#backs_info').hide(); // Hide on mouse leave
        }
    );
			//	}, 1000);	 
    // Toggle on click
   
	 $('.extra_infocon_1').hover(
        function() {
            $('.extra_info').show(); // Show on mouse enter
        }, 
        function() {
            $('.extra_info').hide(); // Hide on mouse leave
        }
    );
	
       // }, 1000);
	
        console.log('.mw-apo-container has loaded!');
		if (window.location.search.includes('gaming')) {
			 if ($('#v_18929376').length > 0){
			$('#v_18929376')[0].click();
			$('body').addClass('darkmode');
			 }
		}
        if (window.location.search.includes('EFG-team')) {
          if (
            $('#v_18929376').length > 0
          ) {
            $('#v_18929376')[0].click();
            $('body').addClass('darkmode');
          }
        }
		if (window.location.search.includes('bitcoin')) {
          setTimeout(function () {
            // $('.back_items').hide();
            $('#v_18929376').click();
            $('body').addClass('darkmode');
            // $('#v_19580996').click();
            $('[data-value-id="v_19580996"], [data-value-id="v_19580997"]').show();
            $('.o_2185385, .o_2185372, .standard_black_text, .standard_black, .wood_text, .wood_section, .specialty_text, .specialty').hide();
            $('.o_2184551, .o_2184553, .o_2184554, .o_2184555, .o_2184556, .o_2184557, .o_2206346').show();
        
            // Update the shipping message
            $('.text_div p').html('CUSTOM BUILT &amp; SHIPPED IN <strong>4 -7 BUSINESS DAYS</strong>');
          }, 500);
        }
	    $('.product-form input[type="radio"]').change(function() {
				 let title_name = $(this).closest('div').find('.title_name').text();
				 if($(this).val() == 'v_19129218'){
					 title_name += '<del>$199</del>'
				 }
				  let title_format = title_name.split('+');
				  let bold_title ='';
				  if(title_format[1] != undefined){
					  bold_title = '+'+title_format[1];
				  }
				 $(this).closest('.chair_summary').find('.new_title_name').remove();
				 $(this).closest('.chair_summary').find('h4').append('<span class="new_title_name">'+title_format[0]+'<b>'+ bold_title+'</b>'+'</span>');
				  
			  })
        clearInterval(checkExist);
    }
}, 100); // check every 100ms
   // }
    // Mobile End
    $(document).ready(function() {
        setTimeout(function() {
            function showhide(et) {
                var show_id = $(et).attr('data-id');
                $('mw-option--type-swatch').hide();
                $('#' + show_id).show();
            }
        }, 2000);
	
		
    });

    $('.custom-product').show();

    $('#days_left').text(days);
});
// }

//DOPPLE CONTROLS FOR AR AND SNAPSHOT
let avAr // The <av-ar> tag
let arDiv // QR code container <div>
let arTriggerButton // Custom AR trigger button
let arCloseButton // Custom AR close
const doppleVisual = document.querySelector('atlatl-visual')
const doppleProduct = document.querySelector('av-product')

document.addEventListener("DOMContentLoaded", () => {
    avAr = document.getElementById('ar-visualizer')
    arDiv = document.querySelector('.custom-ar-div')
    arTriggerButton = document.getElementById('custom-ar-trigger-button')
    arCloseButton = document.getElementById('close-ar-trigger-button')
    if ($(arDiv).css('display') == 'none') {
        arTriggerButton.addEventListener('click', () => {
            arDiv.style.display = 'block'
        })
    }

    arCloseButton.addEventListener('click', () => {
        if ($(arDiv).css('display') == 'block') {
            arDiv.style.display = 'none'
        }
    })
    // The <av-ar> element will then fire an 'ar-code-generated' event once complete
    avAr.addEventListener('ar-code-generated', () => {
        const qrImage = document.getElementById('qr-image')
        qrImage.src = 'data:image/png;base64,' + avAr.qrCode
    })

    // The `<av-ar>` element will fire an 'ar-code-status' event as it updates
    avAr.addEventListener('ar-code-status', (event) => {
        const {
            currentStep,
            totalSteps,
            overallProgress
        } = event.detail
        const label = document.getElementById('ar-progress-percent')
        const bar = document.getElementById('progress-bar')

        label.innerHTML = `AR loading: ${overallProgress * 100}%`
        bar.value = currentStep
        bar.max = totalSteps
    })
    // Get the "Add to Cart" button
    setTimeout(function() {
   
    }, 6000)
})

window.addEventListener('load', async () => {

  await doppleVisual.ready()

    // Initial setup: hide the header initially if the screen width is more than 992px.
    if (window.innerWidth > 992) {
       $('.header').slideUp(0);
    }

    let isHeaderHovered = false;  // Flag to track header hover state

    if (window.innerWidth > 992) {
        // Handle mouse hover on header
        $('.header').hover(
            function() {
                isHeaderHovered = true;
            },
            function() {
                isHeaderHovered = false;
                // Slide up the header only if the mouse is not near the top
                $(document).on('mousemove', function(e) {
                    if (e.clientY > 30 && !isHeaderHovered) {
                       $('.header').slideUp();
                    }
                });
            }
        );

        // Event listener for mouse movement near the top of the page.
        $(document).on('mousemove', function(e) {
            if (e.clientY <= 10 || isHeaderHovered) {
                // If mouse is within the top 10px of the viewport or on the header, slide down the header.
               $('.header').slideDown();
            }
        });
    }
    document.querySelector('.sticky_img').classList.add('dopple_loaded');
    document.querySelector('.mw-apo-price-custom').classList.add('dopple_loaded');
    setTimeout(() => {
console.log('duplicate_id',$('#v_18919714')[0]);
if($('#v_18919714')[0] != undefined && $('#v_18919714')[0] !=  'undefined'){
     $('#v_18919714')[0].click();
}
		
      // Check if the URL contains the query parameter 'drlupo'
	   if (window.location.search.includes('bitcoin')) {
			
			
			$('#v_19580997').click();
	   }
      // Check if the URL contains the query parameter 'drlupo'
      if (window.location.search.includes('drlupo')) {
          // Check if the element exists before interacting with it
          if ($('#v_18919699').length > 0 && $('.mw-option__value[data-value-id="v_18919699"]').length > 0) {
			  $('#v_18929376')[0].click();
              $('#v_18919699')[0].click();
              $('.mw-option__value[data-value-id="v_17479846"]').css('display', 'block');
            
              // Add the discount code without removing 'drlupo'
              var discountCode = "8JN8WESM";
              var urlParams = new URLSearchParams(window.location.search); // Preserve current search parameters
              
              // Check if the discount already exists, if not add it
              if (!urlParams.has('discount')) {
                  urlParams.append('discount', discountCode);
                  var newUrl = `${window.location.pathname}?${urlParams.toString()}`;
                  window.history.replaceState(null, null, newUrl); // Update the URL without reloading the page
              }
          } else {
              console.log('Element not found: #v_17479846 or .mw-option__value[data-value-id="v_17479846"]');
          }
          
      } else {
       // $('#v_18919694')[0].click();
       // $('#v_18142710')[0].click();
        $('[data-value-id="v_18142709"]').hide();
      }
      // Keep this exactly as it is, just add the discount condition
      if (window.location.search.includes('miami_heretics') || window.location.search.includes('discount=HERETICS200') || window.location.search.includes('heretics=true')) {
            setTimeout(function () {
              $('#v_18929376').click();
              $('body').addClass('darkmode');
              $('#v_20110214').click();
            }, 500);
          }
      if (window.location.search.includes('onyx-dunePort-walnut') || window.location.search.includes('onyx-dunePort-walnut=true')) {
            setTimeout(function () {
              $('#v_18919692').click();
              $('#v_18919695').click();
            }, 500);
          }
      if (window.location.search.includes('quartz-ivoryPort-circuitWhite') || window.location.search.includes('quartz-ivoryPort-circuitWhite=true')) {
            setTimeout(function () {
              $('#v_18919682').click();
              $('#v_18919704').click();
              $('#v_18919689').click();
              $('#v_18919698').click();
            }, 500);
          }
      if (window.location.search.includes('onyx-ivoryAthlon-walnut') || window.location.search.includes('onyx-ivoryAthlon-walnut=true')) {
            setTimeout(function () {
              $('#v_18919695').click();
              $('#v_18919683').click();
            }, 500);
          }
      if (window.location.search.includes('quartz-lavenderAthlon-circuitBlack') || window.location.search.includes('quartz-lavenderAthlon-circuitBlack=true')) {
            setTimeout(function () {
              $('#v_18919682').click();
              $('#v_18919704').click();
              $('#v_18919688').click();
              $('#v_18919697').click();
            }, 500);
          }
      if (window.location.search.includes('bitcoin-onyx-ivoryAthlon-cream') || window.location.search.includes('bitcoin-onyx-ivoryAthlon-cream=true')) {
            setTimeout(function () {
              $('#v_18919683').click();
              $('#v_19580996').click();
            }, 500);
          }
      if (window.location.search.includes('quartz-onyxPort-naturalOak') || window.location.search.includes('quartz-onyxPort-naturalOak=true')) {
            setTimeout(function () {
              $('#v_18919682').click();
              $('#v_18919704').click();
              $('#v_18919690').click();
              $('#v_18919694').click();
            }, 500);
          }
      if (window.location.search.includes('onyx-lavenderAthlon-circuitBlack') || window.location.search.includes('onyx-lavenderAthlon-circuitBlack=true')) {
            setTimeout(function () {
              $('#v_18919690').click();
              $('#v_18919697').click();
            }, 500);
          }
      if (window.location.search.includes('quartz-steelAthlon-standardOnyx') || window.location.search.includes('quartz-steelAthlon-standardOnyx=true')) {
            setTimeout(function () {
              $('#v_18919682').click();
              $('#v_18919704').click();
              $('#v_18919685').click();
            }, 500);
          }
      if (window.location.search.includes('AMERICA') || window.location.search.includes('AMERICA=true')) {
            setTimeout(function () {
              $('#v_18919683').click();
              $('#v_18919682').click();
              $('#v_18919704').click();
              $('#v_20616603').click();
            }, 500);
          }
	  console.log('loading_price');
    console.log('Found .loading_price:', $('.loading_price').length);
    console.log('Found .price-item--regular:', $('.price-item--regular').length);
    console.log('Found .extra_price:', $('.extra_price').length);

    $('.loading_price').attr('style', 'opacity:0');
    $('.extra_price').attr('style', 'opacity:1');
    $('.price-item--regular').attr('style', 'opacity:1');
  
      if (window.innerWidth >= 900) {
          doppleProduct.product.setValue('runRotation', true);
      }
      $(".sticky_img").click(function(){
          doppleProduct.product.setValue('runRotation', false);
      });
      // try clicking `sel` every `interval` ms until its wrapper has `selectedClass`
      // or until we've hit `maxTries`
      function clickUntilSelected(
        sel,
        {
          container = '.mw-option__value',
          selectedClass = 'mw-option__value--selected',
          interval = 100,
          maxTries = 20
        } = {}
      ) {
        let tries = 0;
        const timer = setInterval(() => {
          const $input   = $(sel);
          const $wrapper = $input.closest(container);
     // console.log('checked value', $wrapper.find('input:checked').length);
          // if wrapper isn't found or already selected, stop
          if (!$wrapper.length || $wrapper.find('input:checked').length > 0) {
            clearInterval(timer);
            return;
          }
      
          // if we've tried enough times, give up
          if (++tries >= maxTries) {
            clearInterval(timer);
            console.warn(`clickUntilSelected: failed to select ${sel} after ${maxTries} tries`);
            return;
          }
      console.log('input', $input)
          // otherwise, fire the click and try again later
          $input[0].click();
        }, interval);
      }
      
      // batch version
      function clickIfNotSelected(selectors) {
        selectors.forEach(sel => clickUntilSelected(sel));
      }
      
      // your handlers
      $('#v_18929218').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919681',
            '#v_18919684',
            '#v_18919695'
          ]);
        }, 100);
      });
      $('#v_18929219').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919682',
            '#v_18919683',
            '#v_18919694'
          ]);
        }, 100);
      });
      $('#v_18929373').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919681',
            '#v_18919684',
            '#v_18919697'
          ]);
        }, 100);
      });
      $('#v_18929374').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919682',
            '#v_18919685',
            '#v_18919695'
          ]);
        }, 100);
      });
      $('#v_19657504').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919682',
            '#v_18919683',
            '#v_18919698'
          ]);
        }, 100);
      });
      $('#v_19657503').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919681',
            '#v_18919690',
            '#v_18919696'
          ]);
        }, 100);
      });
      $('#v_19657502').click(function() {
        setTimeout(function() {
          clickIfNotSelected([
            '#v_18919682',
            '#v_18919688',
            '#v_18919698'
          ]);
        }, 100);
      });
      $('#v_17990463').click(function() {
        setTimeout(function() {
          $('#v_18142710')[0].click();
          $('[data-value-id="v_18142709"]').hide();
          $('[data-value-id="v_18142710"]').show(); 
        }, 100);
      });
      $('#v_17990464').click(function() {
        setTimeout(function() {
          $('#v_18142709')[0].click();
          $('[data-value-id="v_18142710"]').hide();
          $('[data-value-id="v_18142709"]').show(); 
        }, 100);
      })
      $('#v_18919681').click(function() {
          $('#v_18919705')[0].click();
          setTimeout(function() {
            doppleProduct.product.setValue('cameraView', 'back');
          }, 100);
      });
      $('#v_18919682').click(function() {
          $('#v_18919704')[0].click();
          setTimeout(function() {
            doppleProduct.product.setValue('cameraView', 'back');
          }, 100);
      });
      $('#v_20420817').click(function() {
          $('#v_20420844')[0].click();
          setTimeout(function() {
            doppleProduct.product.setValue('cameraView', 'back');
          }, 100);
      });
      $('#v_20420818').click(function() {
          $('#v_20420843')[0].click();
          setTimeout(function() {
            doppleProduct.product.setValue('cameraView', 'back');
          }, 100);
      });
      $(".o_2184552").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'back');
      });
  
      $(".o_2184551").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'front');
      });
  
      $("[data-id='o_2081591']").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'back');
      });
  
      $("[data-id='o_2081595']").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'front');
      });
	$(".o_2184553").click(function(){
          doppleProduct.product.setValue('runRotation', false);
          doppleProduct.product.setValue('cameraView', 'lowbackAdjust');
      });
      doppleProduct.product.setValue('base', 'fiveSpoke');
      doppleProduct.product.setValue('fabric', 'heatherBlackGAFabric');
  }, 200);
})

$('#nativeUIIconButton-av-ar').click(function() {
    $('.sticky_img').css({
        'z-index': '10000',
    });
});

$('.native-ui__modal-close-button').click(function() {
    $('.sticky_img').css({
        'z-index': '9',
    });
});
$(document).ready(function(){

  if($( window ).width() > 992){
  var height = $(window).height();
  
  
  //console.log('avCanvas='+$('#main-container').innerHeight());
  $('.custom_product_section.product__info-wrapper').attr('style','max-height:'+height+'px; overflow:scroll;');
  window.addEventListener('resize', function(event){
	  height = $(window).height();
  //console.log('resize='+height);
  $('.custom_product_section.product__info-wrapper').attr('style','max-height:'+height+'px;  overflow:scroll;');
 
  
});
  }
  
  
  checkScroll();

    var _st3 = 0;
    $(window).scroll(function() {
        var _n = Date.now(); if (_n - _st3 < 100) return; _st3 = _n;
        checkScroll();
    });

    function checkScroll() {
        if($( window ).width() < 992){
            var scrollTop = $(window).scrollTop();
            var maxScroll = 150; // Distance to scroll before fully hidden
            
            if (scrollTop > 0) {
                $('.mobile_price').addClass('price_fixed');
                
                // Progressive slide with height and opacity
                var scrollProgress = Math.min(scrollTop / maxScroll, 1);
                
                $('.review_img, .affirm-line, .mobileBlkFriday').each(function() {
                    var originalHeight = $(this).data('originalHeight') || $(this).outerHeight();
                    $(this).data('originalHeight', originalHeight);
                    
                    var originalMarginTop = $(this).data('originalMarginTop');
                    if (originalMarginTop === undefined) {
                        originalMarginTop = parseFloat($(this).css('margin-top')) || 0;
                        $(this).data('originalMarginTop', originalMarginTop);
                    }
                    
                    // Calculate margin-top: starts at original, ends at original - 10px
                    var currentMarginTop = originalMarginTop - (10 * scrollProgress);
                    
                    $(this).css({
                        'max-height': (originalHeight * (1 - scrollProgress)) + 'px',
                        'opacity': 1 - scrollProgress,
                        'overflow': 'hidden',
                        'margin-top': currentMarginTop + 'px',
                        'margin-bottom': ($(this).data('originalMarginBottom') || parseFloat($(this).css('margin-bottom'))) * (1 - scrollProgress) + 'px',
                        'padding-top': ($(this).data('originalPaddingTop') || parseFloat($(this).css('padding-top'))) * (1 - scrollProgress) + 'px',
                        'padding-bottom': ($(this).data('originalPaddingBottom') || parseFloat($(this).css('padding-bottom'))) * (1 - scrollProgress) + 'px',
                        'transition': 'none'
                    });
                    
                    // Store original values if not already stored
                    if (!$(this).data('originalMarginBottom')) {
                        $(this).data('originalMarginBottom', parseFloat($(this).css('margin-bottom')) || 0);
                        $(this).data('originalPaddingTop', parseFloat($(this).css('padding-top')) || 0);
                        $(this).data('originalPaddingBottom', parseFloat($(this).css('padding-bottom')) || 0);
                    }
                });
                
            } else {
                $('.mobile_price').removeClass('price_fixed');
                
                $('.review_img, .affirm-line, .mobileBlkFriday').css({
                    'max-height': 'none',
                    'opacity': 1,
                    'margin-top': '',
                    'margin-bottom': '',
                    'padding-top': '',
                    'padding-bottom': '',
                    'transition': 'max-height 0.3s ease, opacity 0.3s ease, margin 0.3s ease, padding 0.3s ease'
                });
            }
        }
    }
 
  // Was polled every 100ms (10×/sec forever, during 3D render loop too).
  // 500ms is plenty responsive for option validation errors and cuts
  // main-thread wake-ups by 5×.
  setInterval(function () {
		$('.option_error').remove();
		var error_html = '';
		$('.mw-stack__item .mw-option__helptext').each(function(){
			if(!$(this).hasClass('mw-hidden')){
				error_html += '<p>'+$(this).text()+'</p>';

			}

		})
	  $('<div id="option_error" class="option_error">'+error_html+'</div>').insertBefore('.affirm-line');
	  }, 500);
  
});

// CONFIGURATION - Change these IDs as needed for different promotions
/*const CONFIG = {
  optionId: 'o_2184551', // The ID of the fabric option container
  promoClass: 'back-promo-banner-o_2184552' // Unique class for this specific banner
};
// Function to insert the promo banner
function insertPromoBanner() {
  const optionContainer = document.getElementById(CONFIG.optionId);
  
  if (!optionContainer) {
    return;
  }
  
  // Find the subtitle within this specific option container
  const subtitle = optionContainer.querySelector('.subtxt');
  const existingBanner = document.querySelector('.' + CONFIG.promoClass);
  
  // Check if banner already exists to avoid duplicates
  if (subtitle && !existingBanner) {
    // Create the promotional banner
    const promoBanner = document.createElement('div');
    promoBanner.className = 'back-promo-banner ' + CONFIG.promoClass;
    promoBanner.innerHTML = `
      <img class="back-promo-banner__text" src="https://cdn.shopify.com/s/files/1/0611/7552/9642/files/cyber_monday_option_banner_v2.png?v=1764612319"/>
    `;
    
    // Insert the banner after the subtitle's parent container
    const parentDiv = subtitle.closest('.mw-stack__item');
    
    if (parentDiv) {
      parentDiv.insertAdjacentElement('afterend', promoBanner);
    }
    
    // Add click handler for the upgrade link
    const upgradeLink = promoBanner.querySelector('.fabric-promo-banner__link');
    if (upgradeLink) {
      upgradeLink.addEventListener('click', function(e) {
        e.preventDefault();
        // Scroll to Port Leather section within this option container
        const portLeatherSection = optionContainer.querySelector('.port_leather');
        if (portLeatherSection) {
          portLeatherSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }
  }
}*/

// Use MutationObserver to watch for APO elements
// const promoObserver = new MutationObserver(function(mutations) {
//   mutations.forEach(function(mutation) {
//     if (mutation.addedNodes.length) {
//       const optionContainer = document.getElementById(CONFIG.optionId);
//       if (optionContainer) {
//         insertPromoBanner();
//         promoObserver.disconnect();
//       }
//     }
//   });
// });

// // Start observing when DOM is ready
// document.addEventListener('DOMContentLoaded', function() {
//   // Try immediately first in case APO is already loaded
//   insertPromoBanner();
  
//   // If not found, start observing
//   if (!document.querySelector('.' + CONFIG.promoClass)) {
//     promoObserver.observe(document.body, {
//       childList: true,
//       subtree: true
//     });
//   }
// });

// // Also try on window load as a fallback
// window.addEventListener('load', function() {
//   insertPromoBanner();
// });

// // Additional check after a delay (in case APO loads very late)
// setTimeout(function() {
//   insertPromoBanner();
// }, 2000);